module.exports = __webpack_public_path__ + "static/media/Move.f7954720.svg";